import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useResizeObserver } from "../../hooks";
import { EventKeys, getActiveElement } from "../../utils";
import TableContainer from "./TableContainer";
import { TableContainerHorizontal } from "./helperComponents";
import { jsx as ___EmotionJSX } from "@emotion/core";

var ScrollWrapper = function ScrollWrapper(_ref) {
  var maxWidth = _ref.maxWidth,
      children = _ref.children,
      hasStickyHeader = _ref.hasStickyHeader,
      maxHeight = _ref.maxHeight,
      shouldScrollHorizontally = _ref.shouldScrollHorizontally;

  // Be used to indicate if table is focused by tab press.
  // This solution can be removed once Safari starts supporting :focus-visible.
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocusedByTab = _useState2[0],
      setIsFocusedByTab = _useState2[1];

  var _useResizeObserver = useResizeObserver(),
      scrollWrapperRef = _useResizeObserver.ref;

  var checkIfHasScrollbar = function checkIfHasScrollbar(isHorizontal) {
    var element = scrollWrapperRef.current;

    if (!element) {
      return false;
    }

    var isScrollableVertically = element.scrollHeight > element.clientHeight;
    var isScrollableHorizontally = isHorizontal && element.scrollWidth > element.clientWidth;
    return isScrollableVertically || isScrollableHorizontally;
  };

  var handleKeyUp = function handleKeyUp(e) {
    if (e.key === EventKeys.TAB && isFocusedByTab !== true && getActiveElement() === scrollWrapperRef.current) {
      setIsFocusedByTab(true);
    }
  };

  var handleBlur = function handleBlur() {
    if (isFocusedByTab === true) {
      setIsFocusedByTab(false);
    }
  };

  var commonProps = {
    onKeyUp: handleKeyUp,
    onBlur: handleBlur,
    isFocusedByTab: isFocusedByTab,
    hasStickyHeader: hasStickyHeader,
    maxHeight: maxHeight,
    ref: scrollWrapperRef
  };

  if (shouldScrollHorizontally) {
    return ___EmotionJSX(TableContainerHorizontal // Helps to understand if table is focused only by tab press.
    , _extends({}, commonProps, {
      maxWidth: maxWidth,
      tabIndex: checkIfHasScrollbar(true) ? 0 : undefined
    }), children);
  }

  return ___EmotionJSX(TableContainer, _extends({}, commonProps, {
    tabIndex: checkIfHasScrollbar(false) ? 0 : undefined
  }), children);
};

ScrollWrapper.displayName = 'ScrollWrapper';
export default ScrollWrapper;